import { gql } from "@apollo/client";

export const GET_MEMBERSHIPS = gql`
  query getMemberships($paging: OffsetPaging, $sorting: [MembershipSort!], $status: MembershipStatus) {
    memberships(paging: $paging, sorting: $sorting, status: $status) {
      nodes {
        _id
        name
      }
      totalCount
    }
  }
`;

export const GET_MEMBERSHIPS_FOR_TABLE = gql`
  query getMemberships($paging: OffsetPaging, $sorting: [MembershipSort!]) {
    memberships(paging: $paging,sorting:$sorting) {
      nodes {
        _id
        name
        cost
        durationType
        status
        createdAt
      }
      totalCount
    }
  }
`;

// These are the same Membership records used by the public membership checkout.
// Keep the checkout catalogue in the membership model so Stripe prices and the
// public presentation cannot drift into a second, independent product store.
export const GET_MEMBERSHIP_CHECKOUT_PRODUCTS = gql`
  query MembershipCheckoutProducts($paging: OffsetPaging!, $sorting: [MembershipSort!]) {
    memberships(paging: $paging, sorting: $sorting) {
      nodes {
        _id
        name
        planKey
        description
        image {
          name
          size
          type
          url
          cloudId
        }
        paymentNote
        installmentsEnabled
        features
        cost
        duration
        durationType
        freeTrial
        status
        stripeSubscriptionPlanId
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

export const GET_MEMBERSHIP_CHECKOUT_PRODUCT = gql`
  query MembershipCheckoutProduct($id: ID!) {
    adminMembership(id: $id) {
      _id
      name
      planKey
      description
      image {
        name
        size
        type
        url
        cloudId
      }
      paymentNote
      installmentsEnabled
      features
      cost
      duration
      durationType
      freeTrial
      status
      stripeSubscriptionPlanId
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_MEMBERSHIP_CHECKOUT_PRODUCT = gql`
  mutation UpdateMembershipCheckoutProduct($id: ID!, $input: AdminUpdateMembershipInput!) {
    adminUpdateMembership(id: $id, input: $input) {
      _id
      updatedAt
    }
  }
`;
